export enum AuthRoutes {
  root = 'auth',
  login = 'login',
  reset = 'reset',
  forgot = 'forgot',
  accept = 'accept',
  agency = 'agency',
}
